var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RealGrid',{ref:"grid",attrs:{"domName":_vm.grid,"settings":_vm.settings},on:{"changePage":_vm.loadData,"click":_vm.click}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }